// Module
var code = "<div agent-type class=\"appRoot\"> <loading-stage></loading-stage> <router-outlet></router-outlet> </div>";
// Exports
module.exports = code;